import React from 'react'
import Container from '../../components/layout/container'
const Footercopy = () => (
  
 
    <Container style={{
      padding:'40px 0px',
      textAlign:'center',
    }}>

    © {new Date().getFullYear()}, Built by <a href="https://1986.io" target="_blank">1986.io</a>

    </Container>

    
)


export default Footercopy
